export default import.meta.ROLLUP_FILE_URL_ITAXUoU0vJaGxS5neHfEHA